import RiskSummaryEvalue from 'components/RiskSummary/RiskSummaryEvalue';
import RiskSummaryMorningstar from 'components/RiskSummary/RiskSummaryMorningstar';
import React from 'react';
import { CustomerType } from 'store/modules/Customers/types';
import { RiskSummaryType } from 'store/modules/RiskSummary/types';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import Store from 'store/store';

const { selectors, actions } = Store;

export interface RiskSummaryTypeExtendedTimeHorizon extends RiskSummaryType {
  risk_tolerance_customer_2?: number;
}

interface RiskSummaryPageProps {
  riskSummaries: Array<RiskSummaryTypeExtendedTimeHorizon>;
  setRiskSummaries: Function;
  invalidateStoreSubset: Function;
  caseCustomers: Array<CustomerType>;
  values: any;
  caseInfo: any;
  setCustomersResponses: (data: any) => void;
  userResponses: Array<any>;
  valid: boolean;
  dirty: boolean;
  reportImages: any;
  setCapacityForLossConfig: Function;
  nextPage: any;
  setNextPage: Function;
  setCase: any;
}

const RiskSummaryPage = ({
  riskSummaries,
  setRiskSummaries,
  invalidateStoreSubset,
  caseCustomers,
  values,
  userResponses = [],
  valid,
  dirty,
  setCustomersResponses,
  reportImages,
  setCapacityForLossConfig,
  nextPage,
  setNextPage,
  caseInfo,
  setCase
}: RiskSummaryPageProps) => {
  const allProps = {
    riskSummaries,
    setRiskSummaries,
    invalidateStoreSubset,
    caseCustomers,
    caseInfo,
    values,
    userResponses,
    valid,
    dirty,
    setCustomersResponses,
    reportImages,
    setCapacityForLossConfig,
    nextPage,
    setNextPage,
    setCase
  };

  if (caseInfo.riskProfiler === 'Morningstar') {
    return <RiskSummaryMorningstar {...allProps} />;
  } else if (caseInfo.riskProfiler === 'EValue') {
    return <RiskSummaryEvalue {...allProps} />;
  } else {
    return <div>Invalid risk profiler selected.</div>;
  }
};

export default compose(
  connect(
    (state: any) => ({
      caseInfo: selectors.caseSelectors.case(state)
    }),
    {
      setCase: actions.caseActions.setCaseInfo
    }
  )
)(RiskSummaryPage);
